<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              SIREN : <span style="color: #349ee2" class="mr-2">{{ dataSiren.siren }}</span>/
              <span style="color: #d9418b" class="mr-2">{{ dataSiren.raison_sociale }}</span> (OAG <b style="color: #ff0032;">{{dataSiren.oag}}</b> / OAP <b style="color: #ffa434;">{{dataSiren.oap}}</b>)
            </strong>
          </div>
          <b-form id="fiche-siren" v-if="sirenFound()">
            <b-tabs v-model="tabIndex">
              <b-tab>
                <template slot="title">
                  {{ tabs[0] }}
                </template>
                <b-card-body>
                  <b-row>
                    <b-col sm="4">
                      <span><b>Raison Sociale</b> : </span>
                      <span>{{ dataSiren.raison_sociale }}</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Délégation Commerciale</b>  : </span>
                      <span v-if="delegationCommerciale">{{ delegationCommerciale.nom }}</span>
                      <span v-else>N.D.</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Statut Prest'IJ</b> : </span>
                      <span v-if="statutPrestij">{{ statutPrestij.libelle }}</span>
                      <span v-else>N.D.</span>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col sm="4">
                      <span><b>SIREN </b>: </span>
                      <span>{{ dataSiren.siren }}</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Segment Gestion</b> : </span>
                      <span v-if="segmentGestion != null">{{ segmentGestion.libelle }}</span>
                      <span v-else>N.D.</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>DSN</b> : </span>
                      <span v-if="segmentCommercial">{{ segmentCommercial.libelle }}</span>
                      <span v-else>N.D.</span>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col sm="4">
                      <span><b>NIC du siège</b> : </span>
                      <span v-if="dataSiren.nic_siege">{{ dataSiren.nic_siege }}</span>
                      <span v-else>N.D.</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Segment Commercial</b> : </span>
                      <span v-if="segmentCommercial">{{ segmentCommercial.libelle }}</span>
                      <span v-else>N.D.</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>SIRH</b> : </span>
                      <span v-if="sirh">{{ sirh.libelle }}
                        <span v-if="addSirhAutre"> ({{ sirhAutre }})</span>
                      </span>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col sm="4">
                      <span><b>NIC</b> : </span>
                      <span v-if="hasDispenseBs">Oui</span>
                      <span v-else>Non</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Nb</b> : </span>
                      <span v-if="hasDispenseBs">Oui</span>
                      <span v-else>Non</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Format CEV</b> : </span>
                      <span v-if="formatDeclarationCev">{{ formatDeclarationCev.libelle }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col sm="4">
                      <span><b>N°PM</b> : </span>
                      <span v-if="isCea">Oui</span>
                      <span v-else>Non</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Effectif</b> : </span>
                      <span>N.D.</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Mode Cea</b> : </span>
                      <span v-if="isCea">Oui</span>
                      <span v-else>Non</span>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col sm="4">
                      <span><b>Code Postal</b> : </span>
                      <span>{{ dataSiren.cp }} (Région : {{ calculatedDelegation }})</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Produits</b> : </span>
                      <span>N.D.</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Groupe de SIREN</b> : </span>
                      <span v-for="(group, index) in dataSiren.groupe_sirens">
                          <span v-if="index != 0"> ; </span> {{ group.libelle }}
                      </span>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col sm="4">
                      <span><b>Dispense BS</b> : </span>
                      <span v-if="hasDispenseBs">Oui</span>
                      <span v-else>Non</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Subrogation</b> : </span>
                      <span v-if="hasSubrogation">Oui</span>
                      <span v-else>Non</span>
                    </b-col>
                    <b-col sm="4">
                      <span><b>Grille Salaire :</b></span>
                      <span v-if="grilleSalaire"> {{ grilleSalaire.libelle }}</span>
                      <span v-else>N.D.</span>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-tab>
              <b-tab>
                <template slot="title">
                  {{ tabs[1] }}
                </template>
                <b-card-body>
                  <equipement-contrat-tab v-if="equipementContratReady"
                                          :equipement-contrat-data-siren="equipementContratDataSiren"
                                          :equipement-contrat-data-table-x="equipementContratDataTableX"
                                          :equipement-contrat-data-etablissement="equipementContratDataEtablissement"
                                          :equipement-contrat-data-nb-sal-total="equipementContratDataNbSalTotal">
                  </equipement-contrat-tab>
                </b-card-body>
              </b-tab>
              <b-tab>
                <template slot="title">
                  {{ tabs[2] }}
                </template>
                <b-card-body>
                  <actualite-pilotage v-if="userCevActiveReady"
                                      :actualite-pilotage-data-siren="equipementContratDataSiren"
                                      :user-cev-active-count="userCevActiveCount"
                                      :siren="siren">
                  </actualite-pilotage>
                </b-card-body>
              </b-tab>
              <b-tab>
                <template slot="title">
                  {{ tabs[3] }}
                </template>
                <b-card-body>
                  <contact v-if="userCevActiveReady && adminCevDoublonReady" :user-cev-active="userCevActive" :admin-cev-doublon="adminCevDoublon"></contact>
                </b-card-body>
              </b-tab>
              <b-tab v-show="canModify">
                <template slot="title">
                  {{ tabs[4] }}
                </template>
                <div class="card">
                  <div class="card-smallHeader" style="background-color: #c9d0e5;">
                    <i class="fa fa-justify mr-2"></i>
                    <span style="color:#73818f"><b>Paramétrages services Gestion</b></span>
                  </div>
                  <div class="card-body">
                  <b-row class="mt-1">
                    <b-col sm="4">
                      <span>Segment Commercial :</span>
                      <span>
                        <b-form-select id="segmentCommercial"
                                       :plain="true"
                                       :options="allSegmentsCommerciaux"
                                       v-model="segmentCommercialId"
                                       :disabled="isNotAllowed('segmentCommercial')">
                        </b-form-select>
                      </span>
                    </b-col>
                    <b-col sm="4">
                      <span>Délégation Commerciale  :</span>
                      <span>
                        <b-form-select id="delegationCommerciale"
                                       :plain="true"
                                       :options="allDelegations"
                                       v-model="delegationCommercialeId"
                                       :disabled="isNotAllowed('delegationCommerciale')">
                        </b-form-select>
                      </span>
                    </b-col>
                    <b-col sm="4">
                      <span>Segment Gestion :</span>
                      <span>
                        <b-form-select id="segmentGestion"
                                       :plain="true"
                                       :options="allSegmentsGestion"
                                       v-model="segmentGestionId"
                                       :disabled="isNotAllowed('segmentGestion')">
                        </b-form-select>
                      </span>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col sm="4">
                      <span>Statut Prest'IJ : </span>
                      <span>
                        <b-form-select id="statutPrestij"
                                       :plain="true"
                                       :options="allStatusPrestij"
                                       v-model="statutPrestijId"
                                       :disabled="isNotAllowed('statutPrestij')">
                        </b-form-select>
                      </span>
                    </b-col>
                    <b-col sm="4">
                      <span>Format CEV : </span>
                      <span>
                        <b-form-select id="formatDeclarationCev"
                                       :plain="true"
                                       :options="allformatDeclarationCev"
                                       v-model="formatDeclarationCevId"
                                       :disabled="isNotAllowed('formatDeclarationCev')">
                        </b-form-select>
                      </span>
                    </b-col>
                    <b-col sm="4">
                      <span>Grille Salaire : </span>
                      <span>
                        <b-form-select id="grilleSalaire"
                                       :plain="true"
                                       :options="allGrilleSalaire"
                                       v-model="grilleSalaireId"
                                       :disabled="isNotAllowed('formatDeclarationCev')">
                        </b-form-select>
                      </span>
                    </b-col>
                  </b-row>
                <b-row class="mt-3">
                  <b-col sm="4">
                    <span>SIRH :</span>
                    <span>
                      <b-form-select id="sirh"
                                      :plain="true"
                                      @change="sirhChanged"
                                      :options="allsirh"
                                      v-model="sirhId"
                                      :disabled="isNotAllowed('sirh')">
                      </b-form-select>
                    </span>
                  </b-col>
                  <b-col v-if="addSirhAutre" sm="4">
                      <b-form-group label="SIRH Autre">
                        <b-form-input type="text" id="sirh_autre" v-model="sirhAutre"></b-form-input>
                      </b-form-group>
                  </b-col>
                  <b-col v-else sm="4">

                  </b-col>
                  <b-col sm="4">
                    <span>Activer le produit pour Module Prev' : </span>
                    <b-form-checkbox
                      id="checkbox-active-mp"
                      v-model="activeIntegrationNsiAuto"
                      name="activeIntegrationNsiAuto"
                      switch
                      :disabled="isNotAllowed('formatDeclarationCev')">
                      {{ activeIntegrationNsiAuto ? 'Oui' : 'Non'}}
                    </b-form-checkbox>
                  </b-col>
                </b-row>
                  <b-row class="mt-3">
                    <b-col sm="4">
                      <span>Subrogation : </span>
                      <b-form-checkbox
                        id="checkbox-hasSubrogation"
                        v-model="hasSubrogation"
                        name="hashasSubrogation"
                        switch
                        :disabled="isNotAllowed('hasSubrogation')">
                        {{ hasSubrogation ? 'Oui' : 'Non'}}
                      </b-form-checkbox>
                    </b-col>
                    <b-col sm="4">
                      <span>Mode Cea :
                      <b-form-checkbox
                        id="checkbox-isCea"
                        v-model="isCea"
                        name="hashasSubrogation"
                        switch
                        :disabled="isNotAllowed('isCea')">
                        {{ isCea ? 'Oui' : 'Non'}}
                        </b-form-checkbox>
                      </span>
                    </b-col>
                    <b-col sm="4">
                      <span>Dispense BS :</span>
                      <span>
                       <b-form-checkbox
                         id="checkbox-hasDispenseBs"
                         v-model="hasDispenseBs"
                         name="hashasSubrogation"
                         switch
                         :disabled="isNotAllowed('hasDispenseBs')">
                         {{ hasDispenseBs ? 'Oui' : 'Non'}}
                        </b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <b-button v-if="canModify" class="float-right" style="background-color: #8693BA; color: #fff;"
                    @click="save">
                    <i class="fa fa-save"></i>
                    Enregistrer
                  </b-button>
                  </div>
                </div>
                <br>
                <div class="card">
                  <div class="card-smallHeader" style="background-color: #CFE3CF;" >
                    <i class="fa fa-justify mr-2"></i>
                    <span style="color:#73818f"><b>Dématérialisation</b></span>
                  </div>
                  <div class="card-body">
                    <dematerialisation
                      :siren="siren">
                    </dematerialisation>
                  </div>
                </div>
              </b-tab>
              <b-tab v-show="canModify">
                <template slot="title">
                  {{ tabs[5] }}
                </template>
                <b-card-body>
                  <journal v-if="journalReady" :journal-items="journalItems" :siren="siren"></journal>
                </b-card-body>
              </b-tab>
            </b-tabs>
            <div slot="footer" style="margin-top:25px;">
              <b-button class="mt-2 mb-1 mr-1" variant="secondary" @click="returnBack"><i class="fa fa-arrow-left"></i> Liste
                des Siren
              </b-button>
            </div>
          </b-form>
          <hr>
          <siren-charts v-if="can_see_stats()" :siren="siren"></siren-charts>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken, getUser} from '../../../utils/auth';
  import { hasRule, espaceGestionRules as rules, rules as rulesAdmin } from "@/utils/rulesHelper";
  import EquipementContratTab from './ficheSirenTabs/EquipementContratTab';
  import ActualitePilotage from './ficheSirenTabs/ActualitePilotage';
  import SirenCharts from './SirenCharts';
  import Journal from './ficheSirenTabs/Journal';
  import Contact from './ficheSirenTabs/Contact';
  import Dematerialisation from './ficheSirenTabs/DematerialisationTab';
  import {isEmpty} from "../../../utils/fileHelper";

  export default {
    components: {
      EquipementContratTab,
      ActualitePilotage,
      Contact,
      Journal,
      Dematerialisation,
      SirenCharts,
    },
    data() {
      return {
        isEmpty,
        tabIndex: 0,
        canModify: false,
        siren: this.$route.params.siren,
        id: '',
        allSegmentsCommerciaux: [],
        allSegmentsGestion: [],
        allDelegations: [],
        allStatusPrestij: [],
        allsirh: [],
        allformatDeclarationCev: [],
        allGrilleSalaire: [],
        segmentCommercial: '',
        delegationCommerciale: '',
        segmentGestion: '',
        statutPrestij: '',
        formatDeclarationCev: '',
        grilleSalaire: '',
        segmentCommercialId: '',
        delegationCommercialeId: '',
        segmentGestionId: '',
        statutPrestijId: '',
        formatDeclarationCevId: '',
        grilleSalaireId: '',
        sirhId: '',
        sirh: '',
        activeIntegrationNsiAuto: false,
        hasSubrogation: false,
        isCea: false,
        hasDispenseBs: false,
        dataSiren: {},
        sirenPreference: {},
        tabs: [
          "Identification et Services",
          "Equipement / Contrats",
          "Actualité Pilotage",
          "Contacts",
          "Préferences",
          "Journal",
          //"Dématerialisation",
        ],
        tabsIndexes: [
          "identification",
          "equipement",
          "actualite",
          "contact",
          "preferences",
          "journal",
          //"dematerialisation",
        ],
        addSirhAutre: false,
        sirhAutre: '',
        calculatedDelegation: null,
        equipementContratDataSiren: {},
        equipementContratDataTableX: [],
        journalItems: [],
        equipementContratDataEtablissement: [],
        equipementContratDataNbSalTotal: 0,
        equipementContratReady: false,
        journalReady: false,
        userCevActiveReady: false,
        adminCevDoublonReady: false,
        userCevActive: [],
        adminCevDoublon: [],
        userCevActiveCount: 0,
        adminCevDoublonCount: 0,
        dataDelaiDeclarationHorsBpij: {},
        dataDelaiDeclarationBpij: {},
        dataDelaiTraitementHorsBpij: {},
        dataDelaiTraitementBpij: {},
        dataNbDossierDeclarationHorsBpij: {},
        dataNbDossierDeclarationBpij: {},
        dataNbDossierTraitementHorsBpij: {},
        dataNbDossierTraitementBpij: {},
        dataDetail: {},
        loadingChartDelaiDeclarationHorsBpij: true,
        loadingChartDelaiTraitementHorsBpij: true,
        loadingChartDelaiDeclarationBpij: true,
        loadingChartDelaiTraitementBpij: true,
        loadingChartNbDossierTraitementHorsBpij: true,
        loadingChartNbDossierDeclarationHorsBpij: true,
        loadingChartNbDossierDeclarationBpij: true,
        loadingChartNbDossierTraitementBpij: true,
        user: {},
        userOags: [],
        userOaps: []
      }
    },
    mounted() {
      this.canModify = hasRule(rules.CAN_MODIFY_FICHE_SIREN);
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.siren = this.$route.params.siren;
      this.getInfoSiren();
      this.getCalculatedDelagation();
      this.getSegmentsCommerciaux();
      this.getDelegations();
      this.getSegmentsGestion();
      this.getStatusPrestij();
      this.getAllsirh();
      this.getAllformatDeclarationCev();
      this.getAllGrilleSalaire();
      this.getAdminCevDoublon();
      this.getUserCevActiveCount();
      this.user = getUser();
      this.userOags = this.user.profil_active[0].oags.map(oag => oag.code);
      this.userOaps = this.user.profil_active[0].oaps.map(oap => oap.code);

      let oag = this.dataSiren.oag
      let oap = this.dataSiren.oap

      if (this.userOags.indexOf(oag) > -1 && this.userOaps.indexOf(oap) > -1) {
       this.$swal({
          position: "top",
          type: "warning",
          title: "Attention !",
          text: 'Vous n\'avez pas les habilitations pour consulter cette fiche SIREN',
          showConfirmButton: false,
          timer: 3000
        })
        this.returnBack();
      }
    },
    methods: {
      returnBack() {
        this.$router.push({
          path: "/espace-gestion/sirens",
          query: {si: this.$route.query.si, nc: this.$route.query.nc, rs: this.$route.query.rs, dpt: this.$route.query.dpt, dci: this.$route.query.dci, oag:this.$route.query.oag, oap:this.$route.query.oap}
        })
      },
      getInfoSiren(data, change) {
        // TODO : passer en promise pour faire un await dans le created() et gérer le message de redirection quand le siren n'est pas connu en base
       // return new Promise((resolve, reject) => {
          let self = this;
          let test = null;
          if (data === undefined) {
            data = ['actifs']
          }
          this.$store.commit("IS_LOADING", true);
          this.$axios
            .post("/espaceGestion/siren/show/" + this.siren, { detail_etablissement: data })
            .then(response => {
              this.$store.commit("IS_LOADING", false);
              if(response.data.dataSiren && !isEmpty(response.data.dataSiren)){
                if (this.userOags.indexOf(response.data.dataSiren.oag) > -1 && this.userOaps.indexOf(response.data.dataSiren.oap) > -1) {
                  if(!isEmpty(this.$route.query.onglet) && isEmpty(change)) {
                    this.tabIndex = this.tabsIndexes.indexOf(this.$route.query.onglet);
                  }
                  this.dataSiren = response.data.dataSiren;
                  this.segmentCommercial = response.data.dataSiren.preference.segment_commercial;
                  this.sirh = response.data.dataSiren.preference.sirh;
                  this.delegationCommerciale = response.data.dataSiren.preference.delegation_commerciale;
                  this.segmentGestion = response.data.dataSiren.preference.segment_gestion;
                  this.statutPrestij = response.data.dataSiren.preference.statut_prestij;
                  this.formatDeclarationCev = response.data.dataSiren.preference.format_declaration_cev;
                  this.grilleSalaire = response.data.dataSiren.preference.grille_salaire;
                  this.equipementContratDataSiren = response.data.dataSiren;
                  this.equipementContratDataTableX = response.data.equipementContratSiren.TableX;
                  this.equipementContratDataEtablissement = response.data.equipementContratSiren.etablissements;
                  this.equipementContratDataNbSalTotal = response.data.equipementContratSiren.totalSalarieNumber;
                  this.equipementContratReady = true;
                  if (response.data.dataSiren.suivi_siren.length > 0) {
                    this.journalItems = response.data.dataSiren.suivi_siren;
                    this.journalReady = true;
                  }
                  if (response.data.dataSiren.preference.segment_commercial !== null) {
                    this.segmentCommercialId = response.data.dataSiren.preference.segment_commercial.id;
                  }
                  if (response.data.dataSiren.preference.sirh !== null) {
                    this.sirhId = response.data.dataSiren.preference.sirh.id;
                  }
                  if (response.data.dataSiren.preference.sirh_autre !== null) {
                    this.addSirhAutre = true;
                    this.sirhAutre = response.data.dataSiren.preference.sirh_autre;
                  }
                  if (response.data.dataSiren.preference.delegation_commerciale !== null) {
                    this.delegationCommercialeId = response.data.dataSiren.preference.delegation_commerciale.id;
                  }
                  if (response.data.dataSiren.preference.segment_gestion !== null) {
                    this.segmentGestionId = response.data.dataSiren.preference.segment_gestion.id;
                  }
                  if (response.data.dataSiren.preference.statut_prestij !== null) {
                    this.statutPrestijId = response.data.dataSiren.preference.statut_prestij.id;
                  }
                  if (response.data.dataSiren.preference.format_declaration_cev !== null) {
                    this.formatDeclarationCevId = response.data.dataSiren.preference.format_declaration_cev.id;
                  }
                  if (response.data.dataSiren.preference.grille_salaire_id !== null) {
                    this.grilleSalaireId = response.data.dataSiren.preference.grille_salaire_id;
                  }
                  this.activeIntegrationNsiAuto = response.data.dataSiren.preference.is_active_integration_nsi_auto;
                  this.hasSubrogation = response.data.dataSiren.preference.has_subrogation;
                  this.isCea = response.data.dataSiren.preference.is_cea;
                  this.hasDispenseBs = response.data.dataSiren.preference.has_dispense_bs;
                  this.id = response.data.dataSiren.id;
                } else {
                  this.$swal({
                    position: "top",
                    type: "warning",
                    title: "Attention !",
                    text: 'Vous n\'avez pas les habilitations pour consulter cette fiche SIREN',
                    showConfirmButton: false,
                    timer: 3000
                  })
                  
                  this.returnBack();
                }
              }else{
                this.$swal({
                    position: "top",
                    type: "warning",
                    title: "Attention !",
                    text: 'SIREN inconnu',
                    showConfirmButton: false,
                    timer: 3000
                  })
                  
                  this.returnBack();            
              }
              
            })
            .catch((error) => {
              console.log(error)
            });
            //resolve();
          //});
          
      },
      getCalculatedDelagation() {
        this.$axios
          .get("/espaceGestion/siren/calculatedDelegation/"+this.siren)
          .then(response => {
            this.calculatedDelegation = response.data.delegation ? response.data.delegation.nom : null;
          });

      },
      getSegmentsCommerciaux() {
        let self = this;
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceGestion/dossier/getAllSegmentCommerciaux")
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            let segments = response.data.data;
            for (let key in segments) {
              this.allSegmentsCommerciaux.push({
                text: segments[key].libelle,
                value: segments[key].id
              });
            }
            this.allSegmentsCommerciaux.sort();
            this.allSegmentsCommerciaux.unshift({text: 'N.D', value: null});
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      getDelegations() {
        let self = this;
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceGestion/dossier/getAllDelegations")
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            let delegations = response.data.data;
            for (let key in delegations) {
              this.allDelegations.push({
                text: delegations[key].nom,
                value: delegations[key].id
              });
            }
            this.allDelegations.unshift({text: 'N.D', value: null});
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      getSegmentsGestion() {
        let self = this
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceGestion/dossier/getAllSegment")
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            let segments = response.data.data;
            for (let key in segments) {
              this.allSegmentsGestion.push({
                text: segments[key].libelle,
                value: segments[key].id
              });
            }
            this.allSegmentsGestion.sort();
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      getStatusPrestij() {
        let self = this;
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceGestion/dossier/getStatusPrestij")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            let status = response.data.data;
            for (let key in status) {
              this.allStatusPrestij.push({
                text: status[key].libelle,
                value: status[key].id
              });
            }
            this.allStatusPrestij.sort();
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      getAllsirh() {
        let self = this;
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceGestion/siren/getAllSirh")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            let sirhs = response.data.sirh;
            for (let key in sirhs) {
              this.allsirh.push({
                text: sirhs[key].libelle,
                value: sirhs[key].id
              });
            }
            this.allsirh.unshift({text: 'N.D', value: null});
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      getAllformatDeclarationCev() {
        let self = this;
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceGestion/siren/getAllFormatDeclarationCev")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            let formats = response.data.data;
            for (let key in formats) {
              this.allformatDeclarationCev.push({
                text: formats[key].libelle,
                value: formats[key].id
              });
            }
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      save() {
        let self = this;
        this.sirenPreference.siren_id = this.id;
        this.sirenPreference.segment_commercial_id = this.segmentCommercialId;
        this.sirenPreference.delegation_commerciale_id = this.delegationCommercialeId;
        this.sirenPreference.segment_gestion_id = this.segmentGestionId;
        this.sirenPreference.status_prestij_id = this.statutPrestijId;
        this.sirenPreference.sirh_id = this.sirhId;
        this.sirenPreference.format_declaration_cev_id = this.formatDeclarationCevId;
        this.sirenPreference.has_subrogation = this.hasSubrogation;
        this.sirenPreference.is_cea = this.isCea;
        this.sirenPreference.has_dispense_bs = this.hasDispenseBs;
        this.sirenPreference.sirh_autre = this.sirhAutre;
        this.sirenPreference.grille_salaire_id = this.grilleSalaireId;
        this.sirenPreference.is_active_integration_nsi_auto = this.activeIntegrationNsiAuto;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .post("/espaceGestion/siren/editPreference/" + this.siren, this.sirenPreference)
          .then(response => {
            if (response.data.dataSiren.suivi_siren.length > 0) {
              this.journalItems = response.data.dataSiren.suivi_siren;
              this.$event.emit('changeSirenPreferences', this.journalItems);
            }
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: 'top',
              type: 'success',
              title: 'Confirmation',
              text: 'Modifications bien enregistrées',
              showConfirmButton: false,
              timer: 3000
            });
          })
          .catch(function (error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      sirhChanged() {
        this.sirhAutre = '';
        this.addSirhAutre = this.sirhId === 20;
      },
      isNotAllowed(field) {
        switch (field) {
          case 'segmentCommercial' :
            return !hasRule(rules.CAN_CHANGE_PREFERENCE_SEGMENT_COM);
            break;
          case 'delegationCommerciale' :
            return !hasRule(rules.CAN_CHANGE_PREFERENCE_DELEGATION);
            break;
          case 'segmentGestion' :
            return !hasRule(rules.CAN_CHANGE_PREFERENCE_SEGMENT_GEST);
            break;
          case 'statutPrestij' :
            return !hasRule(rules.CAN_CHANGE_PREFERENCE_PRESTIJ);
            break;
          case 'sirh' :
            return !hasRule(rules.CAN_CHANGE_PREFERENCE_SIRH);
            break;
          case 'formatDeclarationCev' :
            return !hasRule(rules.CAN_CHANGE_PREFERENCE_FORMAT_CEV);
            break;
          case 'hasSubrogation' :
            return !hasRule(rules.CAN_CHANGE_PREFERENCE_SUBROGATION);
            break;
          case 'isCea' :
            return !hasRule(rules.CAN_CHANGE_PREFERENCE_CEA);
            break;
          case 'hasDispenseBs' :
            return !hasRule(rules.CAN_CHANGE_PREFERENCE_DISPENSE_BS);
            break;
          default :
            return true;
        }
      },
      getUserCevActiveCount() {
        this.$axios
          .get("/espaceGestion/siren/userCevActive/"+this.siren)
          .then(response => {
            this.userCevActive = response.data.result;
            this.userCevActiveCount = this.userCevActive.length;
            this.userCevActiveReady = true;
          })
          .catch((error) => console.log(error));
      },
      getAdminCevDoublon() {
        this.$axios
          .get("/espaceGestion/siren/getAdminCevDoublon/"+this.siren)
          .then(response => {
            this.adminCevDoublon = response.data.result;
            this.adminCevDoublonCount = this.adminCevDoublon.length;
            this.adminCevDoublonReady = true;
          })
          .catch((error) => console.log(error));
      },
      sirenFound() {
        return !isEmpty(this.dataSiren);
      },
      can_see_stats() {
        return hasRule(rulesAdmin.IS_ADMIN)
      },
      getAllGrilleSalaire() {
        this.$axios
          .get("/espaceGestion/produit/gestion-grille")
          .then(response => {
            let grillesSalaire = response.data.grillesSalaire;
            for (let key in grillesSalaire) {
              this.allGrilleSalaire.push({
                text: grillesSalaire[key].libelle,
                value: grillesSalaire[key].id
              });
            }
          })
          .catch(() => {
            this.handleError()
          });
      }
    }
  }
</script>

